<template>
    <div class="modal-container">
        <el-dialog
            title="填写快递"
            width="500px"
            custom-class="modal-wrap"
            :close-on-click-modal="false"
            :visible.sync="showModal"
            :before-close="onModal_close"
        >
            <div class="modal-inner">
                <div class="text-2">
                    <div class="label">快递公司：</div>
                    <input type="text" placeholder="请输入您邮寄商品的快递公司" v-model="company" />
                </div>
                <div class="text-2">
                    <div class="label">物流单号：</div>
                    <input type="text" placeholder="请输入您邮寄商品的快递单号" v-model="code" />
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="btnFlexBox">
                    <div class="btn btn-ripple" @click="submit_wuliu">确定</div>
                    <div class="btn2 btn-ripple" @click="showModal = false">取消</div>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import refund from '@/shop-actions/refund'

import { mapState } from 'vuex'

export default {
    name: 'modal-wuliu',
    components: {},
    props: ['curr'],
    data() {
        return {
            showModal: false,
            company: '',
            code: '',
        }
    },
    computed: {
        ...mapState(['baseInfo']),
    },
    watch: {},

    mounted() {
        // this.creatQrCode();
    },

    methods: {
        submit_wuliu() {
            let { company, code } = this
            if (!company) {
                alertErr('请输入物流公司')
                return
            }
            if (!code) {
                alertErr('请输入快递单号')
                return
            }

            refund.refund_addKuaidi({
                params: {
                    id: this.$route.query.refund_id,
                    kuaidiCompany: company,
                    kuaidiOrderId: code,
                },
                success: (data) => {
                    alertSucc('提交成功')
                    this.$parent.updateView()
                    this.showModal = false
                },
            })
        },

        onModal_close() {
            this.showModal = false
        },
    },
}
</script>

<style scoped lang="less">
.modal-wrap {
    .modal-inner {
        padding: 20px;

        .text-1 {
            font-weight: bold;
            font-size: 20px;
            color: #ff3d00;
        }
        .text-2 {
            font-size: 14px;
            color: #333333;
            margin-bottom: 20px;

            .flex();

            .label {
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                line-height: 14px;
                width: 80px;
            }
            input {
                flex: 2;
                height: 50px;
                background: #ffffff;
                border-radius: 4px 4px 4px 4px;
                border: 1px solid #eeeeee;
                font-weight: 400;
                font-size: 14px;
                color: #333333;
                line-height: 24px;
                padding-left: 14px;

                &::placeholder {
                    color: #999999;
                }
            }
        }
    }
}

/deep/ .el-dialog__header {
    height: 60px;
    border-bottom: 1px solid #eee;
    background: #f7f7f7;

    .el-dialog__title {
        font-weight: 400;
        font-size: 18px;
        color: #333333;
        line-height: 24px;
    }
    .el-dialog__headerbtn .el-dialog__close {
        font-size: 26px;
        line-height: 26px;
        color: rgb(96, 108, 128);
    }
}

/deep/ .el-dialog__footer {
    text-align: center;

    .btnFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn {
            width: 104px;
            height: 40px;
            background: #ff4d00;
            border-radius: 0px 0px 0px 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            line-height: 14px;
            margin-right: 20px;
            cursor: pointer;
        }

        .btn2 {
            width: 104px;
            height: 40px;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #ff4d00;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            font-size: 14px;
            color: #ff4d00;
            line-height: 14px;
            cursor: pointer;
        }
    }
}
</style>
